import React from 'react';

const SelectState = ({
    items,
    onChange,
    optionTitle,
    formik,
    formikFieldProps,
    value,
    nombre,
    messageDefault
}) => {

    return (
        <>
            <select
                className="form-control"
                onChange={e => onChange(items.find(element => element.nombre == e.target.value))}
                value={value}
            >
                <option value="" disabled selected >Seleccione una opción</option>
                {items && items.length > 0 ? (
                    items.map((item, i) => (
                        <option key={"category-" + i} value={item.nombre}>
                            {item[optionTitle]}
                        </option>
                    ))
                ) : null}
            </select>
        </>
    );
};

export default SelectState;
